import React from "react";
import checked from "./../../../../Images/checked.png";

const MicroBladingInLavelleWhy = () => {
  return (
    <div className="hairSalonInLavelleWhy">
      <h5>
        Why SCENT Hair & Beauty Salon is the Best Choice for Eyebrow
        Microblading in Lavelle Road
      </h5>
      <p>
        At SCENT Hair & Beauty Salon, we pride ourselves on being the top
        destination for eyebrow microblading in Lavelle Road. Here’s what sets
        us apart from other salons:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Expert Technicians:{" "}
          </span>
          <p>
            Our team of highly skilled and trained technicians specializes in
            eyebrow microblading. They bring years of experience and a deep
            understanding of facial anatomy to each session, ensuring that your
            brows are crafted to perfection.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            High-Quality Pigments:{" "}
          </span>
          <p>
            We use only the highest quality pigments that are safe,
            long-lasting, and designed to complement a wide range of skin tones.
            Our pigments are carefully selected to provide a natural finish that
            fades gradually over time, avoiding the harsh lines often associated
            with traditional tattooing.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Hygiene and Safety:{" "}
          </span>
          <p>
            Your safety is our top priority. We adhere to the strictest hygiene
            standards, using sterile equipment and following all recommended
            safety protocols. You can trust that your eyebrow microblading in
            Lavelle Road will be performed in a clean and safe environment.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Personalized Service:{" "}
          </span>
          <p>
            At SCENT Hair & Beauty Salon, we understand that every client has
            unique needs and preferences. We take the time to listen to your
            desires and customize the microblading process to meet your
            expectations. Our personalized approach ensures that you leave our
            salon with eyebrows that truly enhance your beauty.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Relaxing Atmosphere:{" "}
          </span>
          <p>
            Our salon is designed to be a haven of relaxation. From the moment
            you walk through our doors, you’ll be greeted by a warm and inviting
            atmosphere that puts you at ease. We want your microblading
            experience to be as enjoyable as it is transformative.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default MicroBladingInLavelleWhy;
